// Временный доступ сопровождения (contracts/api.md; FR-022 – FR-023г).
import { z } from '../kernel/zod.ts';
import {
  SUPPORT_GRANT_MAX_HOURS,
  SupportGrantSchema,
  SupportGrantStateSchema,
} from '../access/support-grant.ts';
import { fieldMessages } from '../kernel/field-messages.ts';
import { PageQuerySchema, pageSchema, sortSchema } from '../kernel/page.ts';

/** validUntil — срок; createdAt — время выдачи (оно же начало доступа, validFrom). */
export const supportGrantSortFields = ['validUntil', 'createdAt'] as const;

/**
 * GET /api/support-access (T063): администратор — все, сопровождение — свои. q — часть ФИО
 * сопровождения или выдавшего; state; sort со знаком «-» по убыванию, по умолчанию — новые
 * выдачи сверху; курсор.
 */
export const SupportGrantsQuerySchema = z.object({
  ...PageQuerySchema.shape,
  q: z.string().trim().max(200).optional(),
  state: SupportGrantStateSchema.optional(),
  sort: sortSchema(supportGrantSortFields).default('-createdAt'),
});
export type SupportGrantsQuery = z.input<typeof SupportGrantsQuerySchema>;

/** POST /api/support-access: от 1 до 24 часов, причина 5–500 знаков (REC-007). */
export const CreateSupportGrantBodySchema = z.object({
  supportUserId: z.uuid({ error: fieldMessages.user }),
  hours: z
    .number({ error: fieldMessages.hours })
    .int({ error: fieldMessages.hours })
    .min(1, { error: fieldMessages.hours })
    .max(SUPPORT_GRANT_MAX_HOURS, { error: fieldMessages.hours }),
  reason: z
    .string({ error: fieldMessages.reason })
    .trim()
    .min(5, { error: fieldMessages.reason })
    .max(500, { error: fieldMessages.reason }),
});
export type CreateSupportGrantBody = z.input<typeof CreateSupportGrantBodySchema>;

export const SupportGrantListSchema = z.array(SupportGrantSchema);

/** Страница списка выдач: { items, nextCursor }. */
export const SupportGrantsPageSchema = pageSchema(SupportGrantSchema);
